import { Container, injectable} from "inversify";
import type { interfaces } from "inversify";
import {
  PrimariaApi,
  IRequest,
  IRequestClass,
  BrokerDisposableHandler,
} from "@uxland/primary-shell";

const registerRequest =
  (api: PrimariaApi, container: Container) =>
  (command: IRequestClass<any>, handler: interfaces.Newable<any>) => {
    container.bind(handler).to(handler).inTransientScope();
    injectable()(handler);
    const disposable = api.broker.registerRequest(command, (cmd: IRequest<any>) => {
      const handlerInstance = container.get(handler);
      return handlerInstance.handle(cmd);
    });
    return {
      dispose: () => {
        container.isBound(handler) && container.unbind(handler);
        disposable.dispose();
      },
    };
  };

export interface BrokerExtensions {
  registerRequest: (
    command: IRequestClass<any> | string,
    handler: interfaces.Newable<any>,
  ) => BrokerDisposableHandler;
}

export const brokerExtensions = (api: PrimariaApi, container: Container): BrokerExtensions => {
  const register = registerRequest(api, container);
  return {
    registerRequest: register,
  };
};
